<template>
  <div class="popup__text">
    <slot />
  </div>
</template>
